import React from 'react';
import styled from 'styled-components';
import trophyIconUrl from './trophy-icon.png';

const Icon = styled.div`
  width: 86px;
  height: 76px;
  background-image: url(${trophyIconUrl});
  background-repeat: no-repeat;
  background-position: center;
`;

export default function TrophyIcon() {
  return <Icon />;
}
